export default "__VITE_ASSET__WFdmEcGf__"